/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var VerticalSeparatorCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(VerticalSeparatorCellPresenter, _super);
    function VerticalSeparatorCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(VerticalSeparatorCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    VerticalSeparatorCellPresenter.$t = markType(VerticalSeparatorCellPresenter, 'VerticalSeparatorCellPresenter', CellPresenterBase.$);
    return VerticalSeparatorCellPresenter;
}(CellPresenterBase));
export { VerticalSeparatorCellPresenter };
//# sourceMappingURL=VerticalSeparatorCellPresenter.js.map
